import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';
import { CameraService, CBXMediaFile, CBXVideoOption } from 'src/app/services/mobile/camera/camera.service';
import { FormControlTemplatesService } from 'src/app/templates/form-control-templates.service';

@Component({
  selector: 'fpx-video-capture',
  templateUrl: './fpx-video-capture.component.html',
  styleUrls: ['./fpx-video-capture.component.scss']
})
export class FpxVideoCaptureComponent extends BaseFpxControlComponent {

  @ViewChild('defaultTemplate') defaultTemplate: TemplateRef<any>;
  @Input() options:CBXVideoOption;
  @Input() automaticTurnOn:boolean;

  template:TemplateRef<any>;

  constructor(
    _controlContainer : ControlContainer,
    changeDetectorRef:ChangeDetectorRef,
    private _changeDetectorRef: ChangeDetectorRef,
    private _camera:CameraService,
    private _fromControlTemplateService:FormControlTemplatesService
  ) {
    super(_controlContainer, changeDetectorRef);
  }

  protected doPostInit(): void {
    this.template = this.getTemplate(this.ngTemplateName);
    if(this.automaticTurnOn) this.startVideoCapture(); 
  }

  startVideoCapture(){
    // this.options = {
    //   overlayText: 'Please blink your eyes 3 times to get better result'
    // }
    // this._camera.captureVideo(this.options)
    //   .then(
    //     (mediaFile:CBXMediaFile[]) => {
    //       console.log(mediaFile);
    //       this.formControl.setValue(mediaFile[0]);
    //     }
    //   )
    //   .catch(reason => {
    //     console.log("Reason: ", reason);
    //   })
    //   return;
    // capture callback
    var captureSuccess = (mediaFiles) =>{
      console.log('mediaFiles', mediaFiles);
      if(this) {
        this.formControl.setValue(mediaFiles[0]);
      }
    };
    var captureError = (error)=> {
      // navigator['notification']?.alert('Error code: ' + error.code, null, 'Capture Error');
      if(error.code == 3) this.formControl.setValue(error);
    };
    let options = {limit:1, quality: 1, duration: 7};
    navigator['device'].capture.captureVideo(captureSuccess, captureError, options);
  }

  getTemplate(ngTemplateName:string): TemplateRef<any> {
    let tmplt = this._fromControlTemplateService.getTemplate(ngTemplateName);
    return tmplt;
  }

}
